import { useState } from "react";
import axios from "axios";

export default function OTP() {
  const [otp, setOtp] = useState("");
  const [remember, setRemember] = useState(false);

  const userId = sessionStorage.getItem("otpUserId");
  const deviceHash = sessionStorage.getItem("deviceHash");

  async function verify(e) {
    e.preventDefault();

    try {
      const res = await axios.post(
        "http://localhost:5000/api/auth/verify-otp",
        { userId, otp, rememberDevice: remember, deviceHash },
        { withCredentials: true }
      );

      if (res.data.ok) {
        localStorage.setItem("user", JSON.stringify(res.data));
        return (window.location.href = "/");
      }
    } catch {
      alert("Invalid OTP");
    }
  }

  return (
    <div className="flex h-screen justify-center items-center">
      <form className="p-6 shadow rounded bg-white" onSubmit={verify}>
        <h2 className="text-xl font-bold mb-4">Enter OTP</h2>

        <input
          className="border p-2 w-full mb-3"
          placeholder="Enter 6-digit OTP"
          onChange={(e) => setOtp(e.target.value)}
        />

        <label className="flex items-center gap-2 mb-4">
          <input
            type="checkbox"
            checked={remember}
            onChange={() => setRemember(!remember)}
          />
          Remember this device for 7 days
        </label>

        <button className="w-full bg-green-600 text-white py-2 rounded">
          Verify OTP
        </button>
      </form>
    </div>
  );
}
